import { useFormik } from 'formik';
import { useEffect } from 'react';
import { FaCircleCheck } from "react-icons/fa6";
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { selectAuth, stopImpersonating } from '../../../features/authSlice';
import { handleSetUser } from '../../../helpers/SetUserHelper';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { useImpersonateUserMutation } from '../../../services/authApi';
import labelKey from "../../localization/label.json";
import tosterKey from "../../localization/toster.json";

const RevertImpersonateUser = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const auth = useAppSelector(selectAuth);
    const [revertImpersonateUser, { data: imersonateData, isLoading, isSuccess, isError, error }] = useImpersonateUserMutation()
    const initialValues = {
        email: ''
    }
    const formik = useFormik({
        initialValues,
        onSubmit: (values, { resetForm }) => {

            const originalEmail = localStorage.getItem("originalEmail");
            if (originalEmail) {
                revertImpersonateUser({ email: originalEmail });

            } else {
                // console.log("Original email not found in localStorage!");
            }
        }
    })
    useEffect(() => {
        if (isSuccess) {
            handleSetUser({
                dispatch,
                data: imersonateData,
                overrides: {}
            });
            dispatch(stopImpersonating()); // Set isImpersonating to false
            setTimeout(() => {
                navigate("/dashboard");
            }, 0);
            toast.success(tosterKey.impersonateRevertSuccessfully);
            localStorage.removeItem('originalEmail');
            localStorage.removeItem('impersonatePath');

        }
    }, [isSuccess, auth, dispatch, imersonateData, navigate]);
    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';
            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);
    return (
        <>
            {auth.isImpersonating && localStorage.getItem("originalEmail") && (
                <div className="ss-revert-impersonate-wrapper">
                    <form onSubmit={formik.handleSubmit}>
                        <div className='ss-revert-impersonate-bar'>
                            <FaCircleCheck className="text-success fs-5 flex-shrink-0" />
                            <span className='ss-revert-impersonate-text'>
                                You are currently impersonating <span className='fw-bold text-primary'>{auth?.firstName} {auth?.lastName} - {auth?.userAccountID}.</span>
                            </span>
                            <button type='submit' className='ss-revert-impersonate-btn ms-2'>
                                {!isLoading && <>{labelKey.revertIdentity}</>}
                                {isLoading && (
                                    <span className='indicator-progress' style={{ display: 'inline-flex', alignItems: 'center' }}>
                                        {labelKey.pleaseWait}...{' '}
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </>
    )
}

export default RevertImpersonateUser